import { useContext, useEffect } from 'react';
import { StoreContext } from '../StoreProvider';
import useTracking from '../hooks/useTracking';

const Tracking = () => {
    const { seconds, videoPaused, videoEnded, player } = useContext(StoreContext);
    const { sendBeacon } = useTracking();
    const REPORT_INTERVAL = 1;
    let pauseTimer;

    // VIDEO_DESTROYED
    useEffect(() => {
        window.addEventListener('beforeunload', onBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', onBeforeUnload);
        }
    }, []);

    const onBeforeUnload = () => {
        sendBeacon('VIDEO_DESTROYED', { caret: seconds });
    };

    // VIDEO_PLAYING
    useEffect(() => {
        if (!seconds || videoPaused || seconds % REPORT_INTERVAL) {
            return;
        }
        sendBeacon('VIDEO_PLAYING', { caret: seconds });
    }, [seconds]);

    // VIDEO_(RE)STARTED
    useEffect(() => {
        if (videoPaused) {
            return;
        }
        if (seconds < 0.1) {
            sendBeacon('VIDEO_STARTED');
            return;
        }
        sendBeacon('VIDEO_RESTARTED', { caret: Math.round(seconds) });
    }, [videoPaused]);

    // VIDEO_LOADED
    useEffect(() => {
        if (!player) {
            return;
        }
        sendBeacon('VIDEO_LOADED');
    }, [player]);

    // VIDEO_PAUSED
    useEffect(() => {
        if (!videoPaused) {
            return;
        }
        // Todo: clearTimeout on VIDEO_ENDED doesn't seem to work...
        // Timeout to prevent pause event on video end
        pauseTimer = setTimeout(() => {
            if (videoEnded) {
                return;
            }
            sendBeacon('VIDEO_PAUSED', { caret: Math.round(seconds) });
        }, 200);
    }, [videoPaused]);

    // VIDEO_ENDED
    useEffect(() => {
        if (!videoEnded) {
            return;
        }

        clearTimeout(pauseTimer);
        sendBeacon('VIDEO_ENDED');
    }, [videoEnded]);

    return null;
}

export default Tracking;
